import { render, staticRenderFns } from "./salonType.vue?vue&type=template&id=24228be4&"
import script from "./salonType.vue?vue&type=script&lang=js&"
export * from "./salonType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports